import { render, staticRenderFns } from "./AppFooterMenu.vue?vue&type=template&id=38f57692&scoped=true"
import script from "./AppFooterMenu.vue?vue&type=script&lang=ts"
export * from "./AppFooterMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppFooterMenu.vue?vue&type=style&index=0&id=38f57692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f57692",
  null
  
)

export default component.exports